import { computed, ComputedRef, onMounted, reactive, ref, Ref, watch } from '@vue/composition-api';
import type { SwiperOptions } from 'swiper';
import type Swiper from '@/pure-components/swiper/index.vue';
import type Toast from '@/components/toast/index.vue';
import { useKeyboard } from '.';
import { Feed, Maybe } from '@/generated-models';
import { useApolloModel } from 'vue-apollo-model';
import CommentModel from '@/components/comment/commentModel';
export function useSwiper() {
    const swiperOptions = reactive<SwiperOptions>({
        init: false,
        loop: false,
        direction: 'vertical',
        autoHeight: true,
        speed: 200,
        touchStartPreventDefault: false,
        threshold: 100,
        mousewheel: {
            sensitivity: 0.1,
            thresholdDelta: 60,
            thresholdTime: 1000,
        },
        noSwipingSelector: '.comment-box',
    });
    return swiperOptions;
}

export function useFeed(
    swiperRef: Ref<InstanceType<typeof Swiper> | null>,
    feedList: ComputedRef<Maybe<Feed>[] | undefined>,
    playerToast: Ref<InstanceType<typeof Toast> | null>,
) {
    const state = reactive({
        activeIndex: 0,
        isFirstLoad: true,
        showCommentPanel: false,
        slideChangeType: '',
        isFullscreen: false,
        muted: true,
        switchDirection: '',
    });
    const beginTime = ref(0);
    const commentModel = useApolloModel(CommentModel);
    const commentCount = computed(() => commentModel.commentCount);
    onMounted(() => {
        beginTime.value = +new Date();
        watch(() => feedList.value, arr => {
            if (arr && arr.length) {
                if (state.isFirstLoad) {
                    swiperRef.value?.swiper?.init();
                    state.isFirstLoad = false;
                    commentModel.photoId = arr[state.activeIndex]?.photo?.id || '';
                    return;
                }
                setTimeout(() => {
                    swiperRef.value?.swiper?.updateSlides();
                }, 50);
            }
        }, {
            immediate: true,
        });
        watch(() => state.activeIndex, index => {
            const curItem = feedList.value && feedList.value[index];
            if (!curItem || curItem.status === 21) {
                setTimeout(() => {
                    swiperRef.value?.swiper?.slideNext();
                    playerToast.value?.show('作品已失效，已切换到下一个', 2000);
                }, 3000);
            } else {
                beginTime.value = +new Date();
            }
        });
    });
    useKeyboard((e: KeyboardEvent) => {
        state.slideChangeType = 'KEYBOARD';
        if (e.keyCode === 38) {
            swiperRef.value?.swiper?.slidePrev();
        } else {
            swiperRef.value?.swiper?.slideNext();
        }
    });
    return {
        commentCount,
        beginTime,
        state,
    };
}